import React, { useState } from 'react';
import {
  string,
  number,
  oneOfType,
  func,
  bool,
  node
} from 'prop-types';

import { Add, CounterTop } from '@one-thd/sui-icons';
import {
  Button,
  Popover,
  useBreakpoint,
} from '@one-thd/sui-atomic-components';

const AddSpacerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="22" height="22" stroke="#0A0A0A" strokeWidth="2" strokeDasharray="4 4" />
  </svg>
);

const AddFillerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" fill="black" />
    <rect x="1" y="1" width="22" height="22" stroke="#0A0A0A" strokeWidth="2" />
  </svg>
);

export const TouchPoint = ({
  zoom, left, top, width, height, onTouchPoint, onTouchPointForSpacer, onTouchPointForFiller, showText, type, children
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'touchpoint-popover' : undefined;
  const matches = useBreakpoint('sm');
  const isDesktop = matches.greater;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTouchpointClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const PopoverButton = (buttonText, action, icon) => {
    const classNames = isDesktop
      ? 'sui-btn sui-text-base sui-normal-case sui-font-normal sui-gap-x-2'
      : 'sui-btn sui-text-lg sui-normal-case sui-font-normal sui-gap-x-2';
    return (
      <button
        type="button"
        className={classNames}
        // style={{ height: '3.8rem' }}
        onClick={(event) => {
          handleClose();
          action(event);
        }}
      >
        {icon} {buttonText}
      </button>
    );
  };

  return (
    <>
      <Button
        className="touchpoint"
        style={{ left, top, width, height }}
        position="absolute"
        variant="text"
        onClick={handleTouchpointClick}
      >
        <div className="touchpoint-button">
          <Add size="small" color="inherit" />
        </div>
        {showText && (
          <span
            className="touchpoint-text"
            style={{ fontSize: `${1.55 * zoom}rem` }}
          >
            Add a {type.toLowerCase()} cabinet
          </span>
        )}
        {children}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        offset="tight"
        style={{ zIndex: 1000 }}
        data-component="tochpoint-popover"
      >
        <div className="sui-flex sui-flex-col sui-items-start" style={isDesktop ? { } : { paddingBottom: '60px' }}>
          {PopoverButton('Add Cabinet', onTouchPoint, <CounterTop size="regular" />)}
          {/* Hidding Add Filler Option For Now */}
          {/* {PopoverButton('Add Filler', onTouchPoint, <AddFillerIcon />)} */}
          {PopoverButton('Add Spacer', onTouchPointForSpacer, <AddSpacerIcon />)}
          {PopoverButton('Add Filler', onTouchPointForFiller, <AddFillerIcon />)}
        </div>
      </Popover>
    </>
  );
};

TouchPoint.propTypes = {
  zoom: number,
  left: oneOfType([string, number]),
  top: oneOfType([string, number]),
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  onTouchPoint: func,
  onTouchPointForFiller: func,
  onTouchPointForSpacer: func,
  showText: bool,
  type: string,
  children: node,
};

TouchPoint.defaultProps = {
  zoom: 1,
  left: 0,
  top: 0,
  width: 0,
  height: 0,
  onTouchPoint: () => {},
  onTouchPointForFiller: () => {},
  onTouchPointForSpacer: () => {},
  showText: false,
  type: '',
  children: null,
};
